__turbopack_context__.v({
  "wrapper": "content-module__ETHgcW__wrapper",
});
